<template>
  <!-- 添加dom记得适应手机端 -->
  <div class="mapcontainer">
    <div class="infoview">
      <input
        id="btnStop"
        @click="flyToPile"
        type="button"
        class="btn btn-primary"
        value="flyTo"
      />
      <input
        id="btnStop"
        @click="flyToDam"
        type="button"
        class="btn btn-primary"
        value="back"
      />
    </div>
    <Map :url="configUrl" @onload="onMapload" />
  </div>
</template>

<script>
import Map from "../components/mars3d/Map.vue";
import { isPC } from "../../static/util/pqtutil";
let ispc = true;
export default {
  components: {
    Map,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    const scale = 1;
    return {
      isshow: false,
      configUrl: basePathUrl + "static/mapconfig/config.json", // 配置文件
      drawer: false,
      drawerUrl: "",
      // 客户端环境
      ispc: ispc,
      // 地图对象
      map: {},
      // 桩在地图上缩放的比例
      pileScale: scale,
      // 地形开挖对象
      terrainClip: {},
      // 开挖矩形区域参数

      // 开挖深度 * 缩放比例
      clipHeight: 36 * scale,
      // 开挖记录对象数组
      areaItems: [],
      // 桩图层
      pileGraphicLayer: {},
      // 桩数据
      piles: [],
      // 未施工桩图层
      otherPileGraphicLayer: {},
      // 未施工桩数据
      otherPiles: [],
      // 曲线数据
      chartData: {},
      // 曲线option
      chartOption: [
        { title: "电流" },
        { title: "深度" },
        { title: "填料量" },
        { title: "瞬时水量" },
        { title: "瞬时水压" },
      ],
      // 曲线是否显示
      showLeftChart: false,
      showRightChart: false,
      showLeftChart1: false,
      showLeftChart2: false,
      showRightChart1: false,
      showRightChart2: false,
      showRightChart3: false,
      askurl: "http://mcc.wedam.com.cn/zhenchongearth",
      //askurl: "",
    };
  },
  beforeCreate() {
    ispc = isPC(navigator.userAgent);
    let script3 = document.createElement("script");
    script3.type = "text/javascript";
    script3.src =
      "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/CanvasBillboard.js";

    document.head.appendChild(script3);
  },

  methods: {
    // 地图构造完成回调
    onMapload(map) {
      this.map = map;
      this.createdam();

      // this.initTerrainClip()
      // this.initPileGraphicLayer()
    },
    // 跳转到桩
    flyToDam() {
      const { map } = this;
      map.setCameraView({
        lat: 27.232156,
        lng: 102.90111,
        alt: 994,
        heading: 172,
        pitch: -19,
      });
    },
    createdam() {
      let lat = 27.222838;
      let lng = 102.899717;
      // let lat2 = 27.21389;
      // let lng2 = 102.904225;
      let latstap = 0;
      let lngstap = 0.000031 * 6;
      const { map } = this;
      var that = this;
      let url =
        "http://safe.wedam.com.cn/cooling/myapi.php?api=api_get_hive_earth";
      mars3d.Resource.fetchJson({ url }).then((response) => {
        let graphicLayer = new mars3d.layer.GraphicLayer();
        map.addLayer(graphicLayer);

        for (let a = 0; a < response.length; a++) {
          let ele = response[a];
          let gaochen = ele.c_canghao.split("-");
          let baduan = ele.c_where.split("#")[0];
          let llng = lng + baduan * lngstap;
          let llat = lat + baduan * latstap;
          let tempcolor = "#D0DAB1";
          if (ele.c_new_temp > 27) {
            tempcolor = "red";
          } else if (ele.c_new_temp > 25) {
            tempcolor = "orange";
          } else if (ele.c_new_temp > 24) {
            tempcolor = "#CCCC66";
          } else if (ele.c_new_temp > 21) {
            tempcolor = "green";
          } else if (ele.c_new_temp > 17) {
            tempcolor = "lightseagreen";
          } else if (ele.c_new_temp > 15) {
            tempcolor = "dodgerblue";
          } else if (ele.c_new_temp > 13.5) {
            tempcolor = "blue";
          }
          let graphic = new mars3d.graphic.BoxEntity({
            position: [llng, llat, gaochen[0] * 1],
            text: ele.c_where,
            style: {
              dimensions: new Cesium.Cartesian3(
                18.0,
                100.0,
                gaochen[1] * 1 - gaochen[0] * 1
              ),
              color: tempcolor,
              opacity: 1,
              outline: true,
              outlineColor: "#000000",
            },
          });
          graphicLayer.addGraphic(graphic);
        }

        graphicLayer.bindPopup(function (event) {
          // graphicLayer.startEditing(event.graphic)
          // event.graphic.options.style.color = "red"
          // graphicLayer.stopEditing(event.graphic)
          //graphicLayer.removeGraphic(event.graphic) //可行

          const attr = [];
          attr["仓号"] = event.graphic.options.text;
          return mars3d.Util.getTemplateHtml({
            title: "单仓信息",
            template: "all",
            attr: attr,
          });
        });
      });

      //添加冷水机  冷水管路
      let graphicLayerw = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayerw);
      const pilingGraphic2 = new mars3d.graphic.ModelPrimitive({
        position: [lng - 2 * lngstap, lat + 0.000518, 800],
        style: {
          url: this.askurl + "/static/mapconfig/lsjgz.glb",
          spacing: 1,
          scale: 3,
        },
      });
      graphicLayerw.addGraphic(pilingGraphic2);
      let linelsj = [
        [
          [lng - 2 * lngstap, lat + 0.000518, 800],
          [lng, lat + 0.000518, 795],
        ],
        [
          [lng, lat + 0.000518, 795],
          [lng + 34 * lngstap, lat + 0.000518, 795],
        ],
        [
          [lng, lat + 0.000518, 795],
          [lng + lngstap, lat + 0.000518, 772],
        ],
        [
          [lng + lngstap, lat + 0.000518, 772],
          [lng + 33 * lngstap, lat + 0.000518, 772],
        ],
        [
          [lng + lngstap, lat + 0.000518, 772],
          [lng + 2 * lngstap, lat + 0.000518, 753],
        ],
        [
          [lng + 2 * lngstap, lat + 0.000518, 753],
          [lng + 32 * lngstap, lat + 0.000518, 753],
        ],
        [
          [lng + 2 * lngstap, lat + 0.000518, 753],
          [lng + 3 * lngstap, lat + 0.000518, 703],
        ],
        [
          [lng + 3 * lngstap, lat + 0.000518, 703],
          [lng + 31 * lngstap, lat + 0.000518, 703],
        ],
        [
          [lng + 3 * lngstap, lat + 0.000518, 703],
          [lng + 4 * lngstap, lat + 0.000518, 656],
        ],
        [
          [lng + 4 * lngstap, lat + 0.000518, 656],
          [lng + 30 * lngstap, lat + 0.000518, 656],
        ],
      ];
      let graphicLayer2 = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer2); //水管
      for (let xxa = 0; xxa < linelsj.length; xxa++) {
        let graphic2 = new mars3d.graphic.PolylineVolumeEntity({
          positions: linelsj[xxa],
          style: {
            shape: "circle",
            radius: 1,
            cornerType: Cesium.CornerType.BEVELED,
            material: mars3d.MaterialUtil.createMaterialProperty(
              mars3d.MaterialType.LineFlow,
              {
                color: "blue",
                image: "http://mars3d.cn/img/textures/fenceline.png",
                speed: 10,
                repeat_x: 6,
              }
            ),
          },
        });
        graphicLayer2.addGraphic(graphic2); // 还可以另外一种写法: graphic.addTo(graphicLayer)
      }

      //添加栈桥 只有几个 就不走数据库了
      let qiao = [
        {
          gaocheng: 656,
          name: "656马道",
          lang: 27,
          lat: lat + 0.000518,
          lng: lng + 17 * lngstap,
        },
        {
          gaocheng: 703,
          name: "703栈桥",
          lang: 29,
          lat: lat + 0.000518,
          lng: lng + 17 * lngstap,
        },
        {
          gaocheng: 753,
          name: "753栈桥",
          lang: 31,
          lat: lat + 0.000518,
          lng: lng + 17 * lngstap,
        },
        {
          gaocheng: 772,
          name: "772栈桥",
          lang: 33,
          lat: lat + 0.000518,
          lng: lng + 17 * lngstap,
        },
        {
          gaocheng: 795,
          name: "795栈桥",
          lang: 35,
          lat: lat + 0.000518,
          lng: lng + 17 * lngstap,
        },
      ];
      let graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);
      for (var a = 0; a < qiao.length; a++) {
        let eleq = qiao[a];

        let graphic = new mars3d.graphic.BoxEntity({
          position: [eleq.lng, eleq.lat, eleq.gaocheng],
          text: eleq.name,
          style: {
            dimensions: new Cesium.Cartesian3(eleq.lang * 18, 10.0, 0.5),
            color: "gray",
            opacity: 1,
            outline: true,
            outlineColor: "#000000",
          },
        });
        graphicLayer.addGraphic(graphic);

        graphic = new mars3d.graphic.BoxEntity({
          position: [eleq.lng, eleq.lat, eleq.gaocheng + 7],
          text: eleq.name,
          style: {
            dimensions: new Cesium.Cartesian3(eleq.lang * 18, 10.0, 0.5),
            color: "gray",
            opacity: 1,
            outline: true,
            outlineColor: "#000000",
          },
        });
        graphicLayer.addGraphic(graphic);

        for (var ddd = -11; ddd < 12; ddd++) {
          graphic = new mars3d.graphic.CircleEntity({
            position: [
              eleq.lng + lngstap * ddd,
              eleq.lat + 0.000019,
              eleq.gaocheng,
            ],
            style: {
              radius: 1.0,
              diffHeight: 7,
              color: "gray",
              opacity: 1,
              rotationDegree: 45,
            },
          });
          graphicLayer.addGraphic(graphic); // 还可以另外一种写法: graphic.addTo(graphicLayer)
        }
      }
      graphicLayer.bindPopup(function (event) {
        // graphicLayer.startEditing(event.graphic)
        // event.graphic.options.style.color = "red"
        // graphicLayer.stopEditing(event.graphic)
        //graphicLayer.removeGraphic(event.graphic) //可行

        const attr = [];
        attr["名称"] = event.graphic.options.text;
        return mars3d.Util.getTemplateHtml({
          title: "栈桥信息",
          template: "all",
          attr: attr,
        });
      });

      //添加控制柜
      url = "http://safe.wedam.com.cn/cooling/myapi.php?api=api_get_kzg2";
      mars3d.Resource.fetchJson({ url }).then((response) => {
        let graphicLayer = new mars3d.layer.GraphicLayer();
        map.addLayer(graphicLayer); //控制柜
        let graphicLayer2 = new mars3d.layer.GraphicLayer();
        map.addLayer(graphicLayer2); //水管
        const arrData = [];
        for (let a = 0; a < response.length; a++) {
          let ele = response[a];
          let llng = lng + ele.c_block * lngstap;
          let llat = lat + ele.c_block * latstap;
          var color = "black";
          var subt = "损坏";
          if (ele.c_status == 0) {
            color = "green";
            subt = "正常";
          } else if (ele.c_status == 1) {
            color = "red";
            subt = "异常";
          }
          arrData.push({
            position: [llng + lngstap / 5, llat + 0.000518, ele.c_gaocheng],
            lat: llat,
            lng: llng,
            gaocheng: ele.c_gaocheng,
            style: {
              heading: 270,
              scale: 30,
            },
            attr: {
              name: a,
            },
          });

          for (var ff = 0; ff < 6; ff++) {
            //添加水管  添加了两根
            for (var bb = 0; bb < 4; bb++) {
              let graphic2 = new mars3d.graphic.PolylineVolumeEntity({
                positions: [
                  [
                    llng + (lngstap * (ff + 1.8)) / 14,
                    llat,
                    ele.c_gaocheng * 1 + 0.5 + bb * 1.5,
                  ],
                  [
                    llng + (lngstap * (ff + 1.8)) / 14,
                    llat + 0.00053,
                    ele.c_gaocheng * 1 + 0.5 + bb * 1.5,
                  ],
                ],
                style: {
                  shape: "circle",
                  radius: 0.2,
                  cornerType: Cesium.CornerType.BEVELED,
                  material: mars3d.MaterialUtil.createMaterialProperty(
                    mars3d.MaterialType.LineFlow,
                    {
                      color: "#ff0000",
                      image: "http://mars3d.cn/img/textures/fenceline.png",
                      speed: 10,
                      repeat_x: 6,
                    }
                  ),
                },
              });
              graphicLayer2.addGraphic(graphic2); // 还可以另外一种写法: graphic.addTo(graphicLayer)
            }
          }
        }
        const modelCombine = new mars3d.graphic.ModelCombine({
          url: that.askurl + "/static/guizi/gz.glb",
          instances: arrData,
        });
        graphicLayer.addGraphic(modelCombine);

        //控制柜点击之后飞过去
        graphicLayer.bindPopup(function (event) {
          let dd =
            event.graphic.options.instances[
              event.graphic.options.attr.name * 1
            ];

          map.setCameraView({
            lat: dd.lat + 0.001,
            lng: dd.lng,
            alt: dd.gaocheng,
            heading: 181,
            pitch: 0,
          });
        });
        graphicLayer2.bindPopup(function (event) {
          // graphicLayer.startEditing(event.graphic)
          // event.graphic.options.style.color = "red"
          // graphicLayer.stopEditing(event.graphic)
          //graphicLayer.removeGraphic(event.graphic) //可行

          const attr = [];
          attr["回路名称"] = "测试";
          attr["控制仓"] = "1#-001";
          attr["瞬时流量"] = "100L/m";
          attr["瞬时水温"] = "3℃";
          return mars3d.Util.getTemplateHtml({
            title: "回路信息",
            template: "all",
            attr: attr,
          });
        });
      });
      this.startRotate();
    },
    flyToPile() {
      this.isshow = true;
      const { map } = this;
      this.stopRotate();
      let that = this;

      map.setCameraView({
        lat: 27.232156,
        lng: 102.90111,
        alt: 994,
        heading: 172,
        pitch: -19,
      });
      //添加仓
    },
    saygui(text) {
      alert(text);
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this;
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 });
      }
      this.stopRotate();

      this.previousTime = map.clock.currentTime.secondsOfDay;
      map.on(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    stopRotate() {
      const { map, mars3d } = this;
      map.off(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    map_onClockTick(clock) {
      const { map } = this;
      let spinRate = 150;
      let currentTime = map.clock.currentTime.secondsOfDay;
      let delta = (currentTime - this.previousTime) / 1000;
      this.previousTime = currentTime;
      map.scene.camera.rotateRight(-spinRate * delta);
    },
  },
};
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
.right-charts {
  z-index: 800;
  position: absolute;
  right: 22rem;
  top: 10px;
  font-size: 0.9rem;
  border: none;
  color: #ffffff;
  background: none;
}
.left-charts {
  z-index: 800;
  position: absolute;
  left: 0px;
  top: 9rem;
  font-size: 0.8rem;
  border: none;
  color: #ffffff;
  background: none;
}
.phoneCharts {
  height: 13rem;
  overflow: auto;
}
.rightPhoneCharts {
  right: 3rem !important;
}
.pcCharts1 {
  position: absolute !important;
}
.pcCharts2 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts3 {
  position: absolute !important;
}
.pcCharts4 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts5 {
  position: absolute !important;
  top: 21rem;
}
</style>


// WEBPACK FOOTER //
// src/components/dam.vue